import { http, HttpResponse } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { sessionDetails } from '../../data/session-details';
import { apiUrl } from '../apiUrl';

const activeUserSessionsQuery = http.get(apiUrl(AccountApiPaths.activeUserSessions), () =>
    HttpResponse.json(sessionDetails)
);
const endAllActiveUserSession = http.post(apiUrl(AccountApiPaths.endAllActiveUserSessions), () => HttpResponse.json());

export const activeSessionHandlers = [activeUserSessionsQuery, endAllActiveUserSession];
